import React, { Component } from 'react';
import { DROPDOWN } from '../config';
import store from 'store';

export default class RoomSelectionList extends Component {
  constructor(props) {
    super(props);
    let topOffset = 69;
    let leftOffset = 26;
    if (this.props.alignLeft) {
      if (this.props.RWD === 'Mobile') {
        topOffset = 30;
        // topOffset = 48;
        leftOffset = 10;
      }
    } else {
      if (this.props.RWD === 'PC') {
        topOffset = 69;
        leftOffset = 120;
      } else {
        topOffset = 69;
        // topOffset = 48;
        leftOffset = 100;
      }
    }
    this.state = {
      mode: DROPDOWN.CLOSE,
      RWD: this.props.RWD,
      startIndex: 0,
      showLength: 5,
      indexInterval: [0, 1, 2, 3, 4],
      topOffset: topOffset,
      leftOffset: leftOffset,
      currentIndex: 0,
      buttonSize: this.props.RWD === 'PC' ? [107, 35] : [107, 35],
      //buttonSize: this.props.RWD === "PC" ? [80, 35] : [80, 40],
      selectedBgColor: [255, 255, 255, 0.9],
      // selectedBgColor: [85, 85, 85, 0.6],
      // selectedTextColor: [255, 204, 51, 1.0],
      options: this.props.options,
    };
    this.updateList = this.updateList.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.viewChange = this.viewChange.bind(this);
  }

  componentDidMount() {
    store.subscribe(this.viewChange); // add moniter changes from store and set listener
  }

  updateList(options) {
    let { currentHotSpot } = store.getState();
    let currentIndex = 0;
    options.forEach((e, key) => {
      if (e.id === currentHotSpot) {
        currentIndex = key;
      }
    });
    this.setState({
      options: options,
      currentIndex: currentIndex,
    });
  }

  closeList() {
    this.handleClick('close');
  }

  viewChange() {
    let { currentHotSpot } = store.getState();
    this.state.options.forEach((e, key) => {
      if (e.id === currentHotSpot) {
        this.setState({
          currentIndex: key,
        });
      }
    });
  }

  handleClick = (value, id = null) => {
    if (value === 'open' || value === 'close') {
      this.setState({
        mode: value === 'open' ? DROPDOWN.OPEN : DROPDOWN.CLOSE,
      });
    } else {
      if (value === 'up' || value === 'down') {
        let startIndex = this.state.startIndex;
        let showLength = this.state.showLength;
        let optionLength = this.state.options.length;
        if (value === 'down' && startIndex < optionLength - showLength) {
          startIndex = (startIndex + 1) % optionLength;
        } else if (value === 'up' && startIndex > 0)
          startIndex = (startIndex - 1 + optionLength) % optionLength;
        let indexInterval = [];
        for (let i = 0; i < showLength; i++) {
          let index = (startIndex + i) % optionLength;
          indexInterval.push(index);
        }
        this.setState({
          startIndex: startIndex,
          indexInterval: indexInterval,
        });
      } else {
        if (value !== this.state.currentIndex) {
          const { viewButton } = store.getState();
          const { goDependOnState } = viewButton;
          goDependOnState(id);
        }
        this.setState({
          mode: DROPDOWN.CLOSE,
        });
      }
    }
  };

  render() {
    let optionLength = Math.min(
      this.state.options.length,
      this.state.showLength
    );
    let downButtonPos =
      this.state.topOffset + (optionLength + 1) * this.state.buttonSize[1];
    let selectedBgColor = this.state.selectedBgColor;
    let selectedTextColor = this.state.selectedTextColor;
    let buttonSize = this.state.buttonSize;
    if (optionLength === 0) {
      return null;
    }
    let currentLabel = null;
    let currentIndex = this.state.currentIndex;
    currentLabel = this.state.options[currentIndex].label;

    const menuStyle =
      this.props.RWD === 'Mobile'
        ? {
            //   position: 'absolute',
            //   top: '68px',
            //   right: '10px'
          }
        : {
            // position: 'absolute',
            // top: '94px',
            // left: '26px'
          };

    return (
      <div style={menuStyle}>
        {this.state.RWD === 'Mobile' &&
          null
          // <button className="show-dropdown-close-mobile-bt"
          //     style={{top: '0px', left: this.state.leftOffset+'px', width: buttonSize[0], height: buttonSize[1]}}
          //     onClick={(event) => {
          //         if(this.state.mode === DROPDOWN.CLOSE)
          //             this.handleClick("open");
          //         else
          //             this.handleClick("close");
          //         event.stopPropagation();
          //     }}
          // >
          //     {/* <span className="dropdown-close-value">{currentLabel && currentLabel.length > 2 ?
          //                                             currentLabel.substr(0, 2) + "..." :
          //                                             currentLabel}</span> */}
          //     <span className="dropdown-close-value">{currentLabel}</span>
          //     <i className="dropdown-close-down"></i>
          // </button>
        }
        {this.state.mode === DROPDOWN.CLOSE && (
          /*this.state.RWD === "PC" &&*/ <button
            className="show-dropdown-close"
            style={{ height: buttonSize[1] }}
            onClick={event => {
              this.handleClick('open');
              event.stopPropagation();
            }}
          >
            {/* <span className="dropdown-close-value">{currentLabel && currentLabel.length > 5 ?
                                                                currentLabel.substr(0, 5) + "..." :
                                                                currentLabel}</span> */}
            <span className="dropdown-close-value">{currentLabel}</span>
            <span className="dropdown-open-point"></span>
            <i className="dropdown-close-down"></i>
          </button>
        )}
        {this.state.mode === DROPDOWN.OPEN && (
          <div>
            <ul
              className="show-dropdown-open-ul"
              style={{
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                width: buttonSize[0],
                height: buttonSize[1],
              }}
            >
              <button
                className="show-dropdown-open"
                style={{
                  borderBottomLeftRadius: 0,
                  borderBottomRightRadius: 0,
                }}
                onClick={event => {
                  this.handleClick('up');
                  event.stopPropagation();
                }}
              >
                <i className="dropdown-open-up"></i>
              </button>
            </ul>
            {this.state.options.map((e, key) => {
              let indexInterval = this.state.indexInterval;
              if (indexInterval.indexOf(key) >= 0) {
                let offset =
                  this.state.topOffset +
                  (indexInterval.indexOf(key) + 1) * this.state.buttonSize[1];
                if (key === currentIndex) {
                  return (
                    <ul
                      className="dropdown-open-ul"
                      style={{ width: buttonSize[0], height: buttonSize[1] }}
                    >
                      <button
                        key={key}
                        className="dropdown-open-button"
                        id={e.id}
                        // style={{
                        //     top: offset + 'px',
                        //     left: this.state.leftOffset + 'px',
                        //     backgroundColor: 'rgba(' + selectedBgColor + ')',
                        //     // color: 'rgba('+selectedTextColor+')',
                        //     width: buttonSize[0],
                        //     height: buttonSize[1]
                        // }}
                        onClick={event => {
                          this.handleClick(key, e.id);
                          event.stopPropagation();
                        }}
                      >
                        {/* {(this.state.RWD === "PC" && e.label.length > 5) ?
                                                            e.label.substr(0, 5) + "..." :
                                                            (this.state.RWD === "Mobile" && e.label.length > 3) ?
                                                            e.label.substr(0, 3) + "..." :
                                                            e.label 
                                                        } */}
                        <span
                          className="dropdown-open-value"
                          style={{
                            width: buttonSize[0] - 20,
                            display: 'inline',
                          }}
                        >
                          {e.label}
                        </span>
                        <span
                          className="dropdown-open-point"
                          style={{
                            marginLeft: '0px',
                            marginRight: '-5px',
                            right: '5%',
                            top: '35%',
                          }}
                        ></span>
                      </button>
                    </ul>
                  );
                } else {
                  return (
                    <ul
                      className="dropdown-open-ul"
                      style={{
                        position: 'relative',
                        width: buttonSize[0],
                        height: buttonSize[1],
                      }}
                    >
                      <button
                        key={key}
                        className="dropdown-open-button"
                        id={e.id}
                        //style={{ top: offset + 'px', left: this.state.leftOffset + 'px', width: buttonSize[0], height: buttonSize[1] }}
                        onClick={event => {
                          this.handleClick(key, e.id);
                          event.stopPropagation();
                        }}
                      >
                        {/* {(this.state.RWD === "PC" && e.label.length > 5) ?
                                                                e.label.substr(0, 5) + "..." :
                                                                (this.state.RWD === "Mobile" && e.label.length > 3) ?
                                                                e.label.substr(0, 3) + "..." :
                                                                e.label 
                                                            } */}
                        <span
                          className="dropdown-open-value"
                          style={{
                            width: buttonSize[0] - 20,
                            display: 'inline',
                          }}
                        >
                          {e.label}
                        </span>
                      </button>
                    </ul>
                  );
                }
              } else {
                return '';
              }
            })}
            <ul
              className="show-dropdown-open-ul"
              style={{
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
                width: buttonSize[0],
                height: buttonSize[1],
              }}
            >
              <button
                className="show-dropdown-open"
                style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}
                onClick={event => {
                  this.handleClick('down');
                  event.stopPropagation();
                }}
              >
                <i className="dropdown-open-down"></i>
              </button>
            </ul>
          </div>
        )}
      </div>
    );
  }
}
